import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "Other" })((theme) => ({
  page: {
    margin: "20px",
  },
}));
